import React from 'react';
import Link from '@ntuctech/devex-tangram/Link';
import { Grid, Typography } from '@ntuctech/devex-tangram';
import { Container } from './BusinessQuanity';

const BillingAddress = ({ entityData }) => {
  return (
    <Container container>
      <Grid xs={12} item className="no-spacing">
        <Typography variant="titleS">Billing details</Typography>
      </Grid>
      <Grid xs={12} item className="no-spacing">
        <Typography variant="bodyM">
          This will be reflected in your invoice. To edit billing details, send a request to{' '}
          <Link
            ize="m"
            href="mailto:fpvouchers@ntucenterprise.sg?subject=E-Gift Voucher Order"
            className="customer-support-email"
          >
            fpvouchers@fairprice.com.sg
          </Link>
        </Typography>
      </Grid>
      <Grid xs={12} item className="no-spacing">
        <div className="margin-y-24 no-spacing">
          <Typography className="mine-shaft-66" variant="bodySBold">
            Company name
          </Typography>
          <div>
            <Typography variant="bodyM">{entityData?.name}</Typography>
          </div>
        </div>
        <div className="margin-y-24 no-margin-bottom no-spacing">
          <Typography className="mine-shaft-66" variant="bodySBold">
            Company address
          </Typography>
          <div>
            <Typography variant="bodyM">
              {`${entityData?.address?.address || ''} ${entityData?.address?.buildingName || ''} #${
                entityData?.address?.floor || ''
              }-${entityData?.address?.unitNumber || ''} ${entityData?.address?.postalCode || ''}`}
            </Typography>
          </div>
        </div>
      </Grid>
    </Container>
  );
};

export default BillingAddress;
